import { audioSlice, audioWithQuoteSlice, audioWithTextSlice } from './audio';
import { contactSlice } from './contact';
import { coverCarousel } from './cover-carousel';
import { ctaLink } from './cta-link';
import { deprecatedDownloadLink, downloadLink } from './download-link';
import { faqSlice } from './faq';
import { deprecatedHighlightedSlice, highlightedSlice } from './highlighted';
import {
  imageSlice,
  deprecatedImageSlice,
  imageWithQuoteSlice,
  deprecatedImageWithTextSlice,
  imageWithTextSlice,
} from './image';
import { insertSlice } from './insert';
import {
  deprecatedKeyFigure3Slice,
  deprecatedKeyFigureSlice,
  keyFiguresSlice,
} from './key-figure';
import {
  deprecatedFootnoteSlice,
  footnoteSlice,
  listSlice,
} from './list-footnote';
import { childPushsSlice, coldPushSlice } from './pushs';
import { quoteSlice } from './quote';
import {
  chapeauSlice,
  heading2Slice,
  deprecatedChapeauSlice,
  deprecatedHeadingSlice,
  deprecatedSubtitleSlice,
  textSlice,
  deprecatedTextSlice,
  titleSlice,
} from './text';
import { videoSlice, videoWithQuoteSlice, videoWithTextSlice } from './video';

const PRISMIC_TO_PARSER_SLICE = {
  title: titleSlice,
  subtitle: deprecatedSubtitleSlice,
  heading_2: heading2Slice,
  chapeau: deprecatedChapeauSlice,
  headnote: chapeauSlice,
  heading: deprecatedHeadingSlice,
  text: textSlice,
  txt: deprecatedTextSlice,
  faq: faqSlice,
  key_figures_3: deprecatedKeyFigure3Slice,
  key_figure: deprecatedKeyFigureSlice,
  key_numbers: keyFiguresSlice,
  child_pushs: childPushsSlice,
  cold_push: coldPushSlice,
  cover_audio: audioSlice,
  audio_n_txt: audioWithTextSlice,
  audio_n_quote: audioWithQuoteSlice,
  list: listSlice,
  footnote: deprecatedFootnoteSlice,
  footnotes: footnoteSlice,
  quote: quoteSlice,
  insert: insertSlice,
  highlighted: deprecatedHighlightedSlice,
  exergue: highlightedSlice,
  image: imageSlice,
  cover_image: deprecatedImageSlice,
  video_n_caption: videoSlice,
  image_n_txt: deprecatedImageWithTextSlice,
  text_with_image: imageWithTextSlice,
  video_n_txt: videoWithTextSlice,
  image_n_quote: imageWithQuoteSlice,
  video_n_quote: videoWithQuoteSlice,
  link_cta: ctaLink,
  link_download: deprecatedDownloadLink,
  download_links: downloadLink,
  contact: contactSlice,
  cover_carousel: coverCarousel,
};

export default PRISMIC_TO_PARSER_SLICE;
